import React, { ReactElement, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import type YouTubePlayer from 'youtube-player';

import { FONT_SIZES } from '~/constants/typography';
import DawnHorizon from '~/components/backgrounds/DawnHorizon';
import Brand from '~/components/titles/Brand';

import PATHS from './constants/paths';
import { DEFAULT_SETTINGS, DEFAULT_SESSION } from './constants/defaults';
import NavSwitchBoard from './components/NavSwitchBoard';
import NotFound from './pages/NotFound';
import Menu from './pages/Menu';
import Studio from './pages/Studio';
import Classroom from './pages/Classroom';
import Tutorial from './pages/Tutorial';
import NoLoad from './pages/NoLoad';
import Ending from './pages/Ending';
import Production from './pages/Production';
import Arcade from './pages/Arcade';

function FlowGo(): ReactElement {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [session, setSession] = useState(DEFAULT_SESSION);
  const [videoPlayer, setVideoPlayer] = useState<YouTubePlayer>();
  const [playerState, setPlayerState] = useState(NaN);

  // Styling
  const flowGoStyle = {
    fontSize: FONT_SIZES.text,
  };
  const containerStyle = {
    width: '100%',
    textAlign: 'center' as const,
  };
  const centerStyle = {
    display: 'flex',
    minWidth: 350,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column' as const,
  };

  return (
    <div style={flowGoStyle}>
      <div style={containerStyle}>
        <DawnHorizon>
          <div style={centerStyle}>
            <Brand topic="Kanji" />
            <NavSwitchBoard />
            <Routes>
              <Route path="*" element={<NotFound />} />
              <Route
                index
                element={
                  <Menu
                    settings={settings}
                    setSettings={setSettings}
                    videoPlayer={videoPlayer}
                  />
                }
              />
              <Route
                path={PATHS.menu}
                element={
                  <Menu
                    settings={settings}
                    setSettings={setSettings}
                    videoPlayer={videoPlayer}
                  />
                }
              />
              <Route
                path={PATHS.studio}
                element={
                  <Studio
                    session={session}
                    setSession={setSession}
                    videoPlayer={videoPlayer}
                    playerState={playerState}
                    setPlayerState={setPlayerState}
                  />
                }
              />
              <Route path={PATHS.classroom} element={<Classroom />} />
              <Route path={PATHS.tutorial} element={<Tutorial />} />
              <Route path={PATHS.noLoad} element={<NoLoad />} />
              <Route
                path={PATHS.ending}
                element={<Ending settings={settings} />}
              />
              <Route
                path={PATHS.production}
                element={
                  <Production session={session} setSession={setSession} />
                }
              />
            </Routes>
          </div>
        </DawnHorizon>
        <Arcade
          settings={settings}
          session={session}
          videoPlayer={videoPlayer}
          setVideoPlayer={setVideoPlayer}
          setPlayerState={setPlayerState}
        />
      </div>
    </div>
  );
}

export default FlowGo;
